
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi choisir Instagram pour communiquer sur votre marque ?",
    description:
      "Découvrez les avantages d'Instagram pour renforcer la visibilité de votre marque, engager votre audience et bâtir une communication visuelle impactante.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
